import { createClient } from "@supabase/supabase-js";
import type { Database } from "@wheels-crm/shared-types";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy .env.example to apps/web/.env and fill in real values.",
  );
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
